export default {
  newsManagement: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/new-management/new/list.vue'));
    }, '/modules/new-management/new/list');
  },
  newsCategory: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/new-management/category/list.vue'));
    }, '/modules/new-management/category/list');
  },
  newsBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/new-management/new/news-banner.vue'));
    }, '/modules/new-management/new/news-banner');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/new-management.js